import actions from './actions';
const interfaceApi = {
    actions
}

export default interfaceApi


// WEBPACK FOOTER //
// ./src/store/interfaceApi/index.js